import { types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
// import { AxiosResponse } from "axios";

export default {
    async modify(idx: number, param: types.ReqActionGroup): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/action/group/modify/${idx}`, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async list(param: types.ReqActionGroupList): Promise<types.ResActionGroupForAPi> {
        const res = {} as types.ResActionGroupForAPi;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/action/group/list`, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async excelDownload(param: types.ReqActionGroupForExcel) {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/action/group/export/excel `, param, { withCredentials: false, responseType: "blob" });

            return response;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async detail(idx: number): Promise<types.ResActionGroupDetail> {
        const res = {} as types.ResActionGroupDetail;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/action/group/detail/${idx}`, {}, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async change(idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/action/group/change/${idx}`, {}, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async add(param: types.ReqActionGroup) {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/action/group/add	`, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
};
